export const formatRelativeTime = ({ dateString, now = new Date(), t, locale = "en-US" }) => {
  const date = new Date(dateString);
  const diffTime = Math.abs(now.getTime() - date.getTime());
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    if (diffHours === 0) {
      const diffMinutes = Math.floor(diffTime / (1000 * 60));
      return `${diffMinutes} ${t("common.minutesAgo")}`;
    }
    return `${diffHours} ${t("common.hoursAgo")}`;
  }

  if (diffDays < 3) {
    return `${diffDays} ${t("common.daysAgo")}`;
  }

  return date.toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
  });
};

export const getDateGroupLabel = ({ dateString, now = new Date(), t, locale = "en-US" }) => {
  const date = new Date(dateString);
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === now.toDateString()) {
    return t("common.today");
  }

  if (date.toDateString() === yesterday.toDateString()) {
    return t("common.yesterday");
  }

  return date.toLocaleDateString(locale, {
    month: "long",
    day: "numeric",
  });
};
